import { useEffect, useMemo, useState } from 'react';
const createHandler = (predicate, callback, preventDefault) => {
    if (!callback) {
        return;
    }
    return (event) => {
        if (predicate(event)) {
            callback();
            if (preventDefault) {
                event.preventDefault();
            }
        }
    };
};
const useKeys = (predicate, callbacks, preventDefault = true) => {
    useEffect(() => {
        const keyDownHandler = createHandler(predicate, callbacks.keydown, preventDefault);
        const keyUpHandler = createHandler(predicate, callbacks.keyup, preventDefault);
        if (keyUpHandler) {
            document.addEventListener('keyup', keyUpHandler);
        }
        if (keyDownHandler) {
            document.addEventListener('keydown', keyDownHandler);
        }
        return () => {
            if (keyUpHandler) {
                document.removeEventListener('keyup', keyUpHandler);
            }
            if (keyDownHandler) {
                document.removeEventListener('keydown', keyDownHandler);
            }
        };
    }, [predicate, preventDefault, callbacks.keydown, callbacks.keyup]);
};
const useOnKeydown = (keydown, predicate, preventDefault = true) => {
    const callbacks = useMemo(() => ({ keydown }), [keydown]);
    return useKeys(predicate, callbacks, preventDefault);
};
const useIsKeyPressed = (predicate) => {
    const [isPressed, setIsPressed] = useState(false);
    const callbacks = useMemo(() => ({
        keydown: () => setIsPressed(true),
        keyup: () => setIsPressed(false),
    }), []);
    useKeys(predicate, callbacks, false);
    return isPressed;
};
export const useOnEscapeKeyPress = (keydown) => useOnKeydown(keydown, (e) => e.key === 'Escape');
export const useIsShiftPressed = () => useIsKeyPressed((e) => e.key === 'Shift');
export const useIsCtrlPressed = () => useIsKeyPressed((e) => e.key === 'Meta' || e.key === 'Control');
//# sourceMappingURL=useKeyPresses.js.map